module.exports = __webpack_public_path__ + "img/tools.0047e4d8.png";